import translate from "@insite/client-framework/Translate";
import {
    CultureCode,
    IntlProvider,
    isCurrencyCode,
    spireTranslateAdapter,
    useCountriesLanguages,
} from "@sonic-equipment/ui";
// eslint-disable-next-line spire/fenced-imports

import "@sonic/Services/loggingService";
import * as React from "react";
import { ReactNode } from "react";

export function SpireIntlProvider({
    languageCode,
    currencyCode,
    children,
}: {
    languageCode: string | undefined;
    currencyCode: string | undefined;
    children: ReactNode;
}) {
    const defaultCountryCode = "NL";
    const { selectedCountry } = useCountriesLanguages({
        defaultCountryCode,
        defaultLanguageCode: "EN",
    });

    return (
        <IntlProvider
            formattedMessage={spireTranslateAdapter(translate)}
            cultureCode={(languageCode as CultureCode | undefined) || "en-GB"}
            countryCode={selectedCountry?.abbreviation || defaultCountryCode}
            currencyCode={isCurrencyCode(currencyCode) ? currencyCode : "EUR"}
        >
            {children}
        </IntlProvider>
    );
}
